import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ff78b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-identities-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Manage identities", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Name", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Address", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Status", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Subject", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Signed up", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, "Last sign in", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_11 = { class: "grid-cell name" }
const _hoisted_12 = { class: "badge badge-xs" }
const _hoisted_13 = { class: "grid-cell mono dim" }
const _hoisted_14 = { class: "grid-cell date" }
const _hoisted_15 = { class: "grid-cell num dim" }
const _hoisted_16 = { class: "grid-cell date" }
const _hoisted_17 = { class: "grid-cell num dim" }

import { ref } from 'vue'
import { useIdentityApi, UserIdentity, UserIdentitySort } from '@/auth/IdentityApi'
import { DateTime } from 'luxon'
import { DurationUtil } from '@/util/LuxonUtil'
import { isDefined } from '@/util/TypeScriptUtil'
import PaginatedListView from '@/util/PaginatedListView.vue'

enum Status {
  OK = 'OK',
  Stalled = 'Stalled',
  Blocked = 'Blocked',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageIdentitiesPage',
  setup(__props) {

const sortOptions = [
  { value: UserIdentitySort.CreatedDate, label: 'Newest' },
  { value: UserIdentitySort.FamilyName, label: 'Last name' },
  { value: UserIdentitySort.GivenName, label: 'First name' },
]

const sortRef = ref(UserIdentitySort.CreatedDate)

const identityApi = useIdentityApi()

async function fetchPage(options: { search?: string; sort: UserIdentitySort; pageSize: number; next?: string }) {
  sortRef.value = options.sort
  return await identityApi.searchAsync({ text: options.search, sort: options.sort, pageSize: options.pageSize, next: options.next })
}

function getDisplayName(n: UserIdentity) {
  return sortOptions.find(s => s.value === UserIdentitySort.FamilyName) && sortRef.value === UserIdentitySort.FamilyName
    ? [n.familyName, n.givenName].filter(isDefined).join(', ')
    : [n.givenName, n.familyName].filter(isDefined).join(' ')
}

function getStatus(n: UserIdentity): Status {
  return n.blocked ? Status.Blocked : !n.lastSignInDate ? Status.Stalled : Status.OK
}

function statusText(n: UserIdentity) {
  return getStatus(n)
}

function statusClass(n: UserIdentity) {
  return getStatus(n).toLowerCase()
}

function toDateText(dt?: DateTime) {
  return dt?.toLocal().toFormat('yyyy-MM-dd')
}

function toAgeText(dt?: DateTime) {
  return dt ? DurationUtil.toAge(dt.diffNow().negate()) : ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PaginatedListView, {
      fetchPage: fetchPage,
      getRowKey: (n) => n.subject!,
      sortOptions: sortOptions,
      searchPlaceholder: "Search for a name, address, or subject",
      showSearch: true,
      pageSize: 25
    }, {
      header: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10
      ]),
      row: _withCtx(({ item: n }) => [
        _createElementVNode("div", _hoisted_11, _toDisplayString(getDisplayName(n)), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["grid-cell addr", { verified: n.addresses?.at(0)?.verifiedDate }])
        }, _toDisplayString(n.addresses?.at(0)?.address), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["grid-cell status", statusClass(n)])
        }, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(statusText(n)), 1)
        ], 2),
        _createElementVNode("div", _hoisted_13, _toDisplayString(n.subject), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(toDateText(n.createdDate)), 1),
        _createElementVNode("div", _hoisted_15, _toDisplayString(toAgeText(n.createdDate)), 1),
        _createElementVNode("div", _hoisted_16, _toDisplayString(toDateText(n.lastSignInDate)), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(toAgeText(n.lastSignInDate)), 1)
      ]),
      _: 1
    }, 8, ["getRowKey"])
  ]))
}
}

})